import { FC, ReactNode } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { StorageDocumentLink } from '../../../../../components/storage-document-link/index';
import {
  GrantSummaryPlainFields,
  GrantSummaryPlainRow,
} from '../../components/grant-event-summary-layout';
import {
  CompanyIncorporationFormFileEntry,
  getCompanyIncorporationFileName,
} from '../../utils/company-incorporation-event-form.util';

export type CompanyIncorporationDocumentsSummaryProps = {
  additionalNotes?: string;
  editAction?: ReactNode;
  files?: CompanyIncorporationFormFileEntry[];
  notesEditAction?: ReactNode;
  onDocumentClick?: (fileLink: string) => void;
};

export const CompanyIncorporationDocumentsSummary: FC<
  CompanyIncorporationDocumentsSummaryProps
> = ({ additionalNotes, editAction, files, notesEditAction, onDocumentClick }) => {
  const fileItems = files ?? [];

  const documentsValue =
    fileItems.length === 0 ? (
      <span className="truncate text-xs font-[450] text-gray-700">-</span>
    ) : (
      <div className="flex min-w-0 flex-1 flex-col gap-2 overflow-hidden">
        {fileItems.map((file) => {
          const label = getCompanyIncorporationFileName(file);
          const docLink = 'docLink' in file ? file.docLink : undefined;
          const localFile = 'file' in file && file.file instanceof File ? file.file : undefined;

          return (
            <StorageDocumentLink
              key={file.id}
              label={label}
              link={docLink ?? ''}
              localFile={localFile}
              onDocumentClick={onDocumentClick}
            />
          );
        })}
      </div>
    );

  return (
    <>
      <GrantSummaryPlainFields>
        <div className="flex w-full items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <GrantSummaryPlainRow
              label={<AppFormattedMessage id="DOCUMENTS" />}
              value={documentsValue}
            />
          </div>
          {editAction ? <div className="shrink-0 pt-2">{editAction}</div> : null}
        </div>
      </GrantSummaryPlainFields>
      <GrantSummaryPlainFields>
        <div className="flex w-full items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <GrantSummaryPlainRow
              label={<AppFormattedMessage id="ADDITIONAL_NOTES" />}
              value={
                <span className="whitespace-pre-wrap break-words">{additionalNotes || '-'}</span>
              }
            />
          </div>
          {notesEditAction ? <div className="shrink-0 pt-2">{notesEditAction}</div> : null}
        </div>
      </GrantSummaryPlainFields>
    </>
  );
};
